interface SchoolInfoCardProps {
  schoolName: string
  principal?: string
  /** 郵便番号（表示用。未設定は「—」） */
  postalCode: string
  address: string
  phone: string
  email: string
  /** 職場体験の担当者名（はがきに記載する担当者） */
  contactPersonName?: string
}

function SchoolInfoCard({
  schoolName,
  principal,
  postalCode,
  address,
  phone,
  email,
  contactPersonName,
}: SchoolInfoCardProps) {
  type Row = { label: string; value: string; leadingIcon?: 'postal' }
  const fields: Row[] = [{ label: '学校名', value: schoolName }]
  if (principal && principal !== '—') {
    fields.push({ label: '校長名', value: principal })
  }

  // 「住所」欄に郵便番号を合体表示する（郵便番号が未設定なら住所のみ）
  if (postalCode && postalCode !== '—') {
    fields.push({ label: '住所', value: `${postalCode} ${address}`, leadingIcon: 'postal' })
  } else {
    fields.push({ label: '住所', value: address })
  }
  fields.push({ label: '電話番号', value: phone })
  if (contactPersonName) {
    fields.push({ label: '職場体験の担当者名', value: contactPersonName })
  }
  fields.push({ label: 'メールアドレス', value: email })
  return (
    <div className="town-info-card">
      <h3 className="town-info-card__title">学校情報</h3>
      {fields.map(({ label, value, leadingIcon }, i) => (
        <div
          key={label}
          className={`town-detail-field ${i === fields.length - 1 ? 'is-last' : ''}`}
        >
          <div className="town-detail-field__label">{label}</div>
          <div
            className={`town-detail-field__value ${leadingIcon === 'postal' ? 'town-detail-field__value--with-leading' : ''}`}
          >
            {leadingIcon === 'postal' && (
              <span className="town-detail-field__postal-mark" aria-hidden>
                〒
              </span>
            )}
            <span className="town-detail-field__value-text">{value}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SchoolInfoCard
